import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import { BinaryEntityRaw } from '@edgvr-front/binaries/domain';
import { BinariesActions } from '../actions';

export interface BinariesState extends EntityState<void> {
  isUploading: boolean;
}

export const binariesAdapter: EntityAdapter<void> = createEntityAdapter<void>();

export const initialBinariesState: BinariesState =
  binariesAdapter.getInitialState({
    isUploading: false,
  });

const reducer = createReducer(
  initialBinariesState,
  on(BinariesActions.binaryBatchCreate, (state) => ({
    ...state,
    isUploading: true,
  })),
  on(BinariesActions.binaryBatchCreateSuccess, (state) => ({
    ...state,
    isUploading: false,
  })),
  on(BinariesActions.binaryBatchCreateFailure, (state) => ({
    ...state,
    isUploading: false,
  }))
);

export function binariesReducer(
  state: BinariesState | undefined,
  action: Action
) {
  return reducer(state, action);
}
